import { Box } from "@mui/material";
import React from "react";

export default function Picture({ src }) {
  return <Box component="img" src={src} sx={{ width: "100%" }} />;
}
